import React from 'react';

import './index.scss';

const PcNotice = ({ title, notice }) =>{
  const utag = (text) => {
    const pattern = /.*<u>.*<\/u>/;
    const ret = text.match(pattern);
    if(ret !== null){
      const uTagText = ret[0].replace(/^<u>/, '').replace(/<\/u>$/, '');
      const notUtagText = text.replace(ret[0], '');
      return (
        <div>
          <u>{uTagText}</u>
          {notUtagText}
        </div>
      );  
    }
    return ( <span>{text}</span> );
  };
  const DispText = (text) => {
    return(
      text.map(line => (
        <div key={line} className="PcNoticeText">
          {utag(line)}
        </div>
      ))
    );
  };



  return (
    <div className="PcNotice">
      <div className="PcNoticeMain">
        <div className="PcNoticeTitle">{title}</div>
        {DispText(notice)}
      </div>
    </div>
  );
    

};

export default PcNotice;